import 'bootstrap/dist/css/bootstrap.min.css';
import "./../../style.css";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logout } from './../../redux/AuthSlice/authSlice';
import { useEffect, useState, useRef } from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import $ from 'jquery';
import axios from 'axios';
import moment from 'moment';
import { toast } from "react-toastify";
import CopyButton from './CopyButton';
import TextToSpeech from './TextToSpeech';

const APIBASEURL = process.env.REACT_APP_BASE_URL_DEV;

function Dashboard() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [ loggedInUser, setLoggedInUser ] = useState(null);
  const toastId = useRef(null);
  const [ loading, setLoading ] = useState(false);
  // const [ currentChatHistoryId, setCurrentChatHistoryId ] = useState(0);
  const [ isDeletingChat, setIsDeletingChat ] = useState(false);
  const [ lastSelectedCategory, setLastSelectedCategory ] = useState(0);
  const [ lastSelectedSuggestion, setLastSelectedSuggestion ] = useState(0);
  const [ newChatMessage, setNewChatMessage ] = useState(false);
  const [ chatHistories, setChatHistories ] = useState(false);
  const [ newHistories, checkNewHistories ] = useState(false);
  const [ isListening, setIsListening ] = useState(false);
  const [ messages, setMessage ] = useState([]);
  const [ isToggled, setToggle ] = useState(false);
  const [ transcript, setTranscript ] = useState('');
  const divRef = useRef(null);
  const [ expandedItem, setExpandedItem ] = useState(null);
  const [ myEventSource, setMyEventSource ] = useState(null);
  const [ regenerateTranscript, setRegenerateTranscript ] = useState(null);

  const toggleExpand = (index) => {
    if (expandedItem === index) {
      setExpandedItem(null);
    } else {
      setExpandedItem(index);
    }
  };

  // Set up Axios request interceptor
  const handlerLogout = (e) => {
    toastId.current = toast.loading("Session expired, please login again.", {
      position: "top-right",
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      autoClose: 2500,
      theme: "colored",
      type: "success"
    });
    
    setTimeout(() => {
      toast.dismiss( toastId.current);
    }, 2500);
    e.preventDefault();
    localStorage.removeItem('accessToken');
    dispatch(logout());
    navigate('/');
  };

  /** getting History data from server */

  useEffect(() => {
    let apiEndpoint = APIBASEURL+'/chatHistory/getWebHistory';
    let config = {
      method: 'GET',
      maxBodyLength: Infinity,
      url: apiEndpoint,
      headers: { 
        'accept': '*/*', 
        'Authorization': `${localStorage.getItem('accessToken')}`
      }
    };
    axios.request(config)
    .then((response) => {
      setChatHistories(response.data);
     
    })
    .catch((error) => {
      if (error.response && error.response.status === 401) {
      // Unauthorized, handle the 401 error here
      console.log('Unauthorized access! Redirect to login or take other action.');
      localStorage.removeItem('accessToken');
      dispatch(logout());
      navigate('/');
    } else {
      // Handle other errors
      console.error('Error:', error);
    }
    });
  }, [ newHistories, isDeletingChat ]);

  useEffect(() => {
    localStorage.removeItem('registration_data');
    localStorage.removeItem('otp_data');
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) {
      setTimeout(() => {
        navigate('/');
      }, 100);
      
    }
  }, []);

  useEffect(() => {
    const loggedUser = localStorage.getItem('loggedInUser');
    if (loggedUser) {
      setLoggedInUser(JSON.parse(loggedUser));
    }
    const requestInterceptor = axios.interceptors.request.use(
      (config) => {
        setLoading(true);
        return config;
      },
      (error) => {
        toastId.current = toast.loading("Something went wrong, try again.", {
          position: "top-right",
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          autoClose: 2500,
          theme: "colored",
          type: "error"
        });
        
        setTimeout(() => {
          toast.dismiss( toastId.current);
        }, 500);
        setLoading(false);
        return Promise.reject(error);
      }
    );

    // Set up Axios response interceptor
    const responseInterceptor = axios.interceptors.response.use(
      (response) => {
        setLoading(false);
        return response;
      },
      (error) => {
        toastId.current = toast.loading("Something went wrong, try again.", {
          position: "top-right",
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          autoClose: 500,
          theme: "colored",
          type: "error"
        });
        
        setTimeout(() => {
          toast.dismiss( toastId.current);
        }, 2500);
        setLoading(false);
        return Promise.reject(error);
      }
    );

    // Clean up the interceptors when the component unmounts
    return () => {
      axios.interceptors.request.eject(requestInterceptor);
      axios.interceptors.response.eject(responseInterceptor);
    };
  }, []);

  useEffect(() => {
    scrollToBottom();
  }, [ messages ]);
 
  useEffect(() => {
    let apiEndpoint = APIBASEURL+'/suggestionCategory';
    let config = {
      method: 'GET',
      maxBodyLength: Infinity,
      url: apiEndpoint,
      headers: { 
        'accept': '*/*', 
        'Authorization': `${localStorage.getItem('accessToken')}`
      }
    };
    axios.request(config)
    .then((response) => {
      const newObject = {
        from: 'suggestion',
        suggestionCategory: response.data.data ?? [],
        category: response.data.category ?? {},
        suggestions: response.data.suggestions ?? [],
        aiResponse: '',
        time: moment().format('D MMM YYYY, h:mm A')
      }
      const updatedData = [ ...messages, newObject ];
      setMessage(updatedData);
    })
    .catch((error) => {
      if (error.response && error.response.status === 401) {
      // Unauthorized, handle the 401 error here
      console.log('Unauthorized access! Redirect to login or take other action.');
      localStorage.removeItem('accessToken');
      dispatch(logout());
      navigate('/');
    } else {
      // Handle other errors
      console.error('Error:', error);
    }
    });
  }, [ newChatMessage ]);

  const scrollToBottom = () => {
    if (divRef.current) {
      divRef.current.scrollTop = divRef.current.scrollHeight;
    }
  };

  let HandleChooseCategory = (e) => {
    const dataAttr1 = e.target.getAttribute('data-category-id');
    const dataAttr2 = e.target.getAttribute('data-category-title');
    setLastSelectedCategory(dataAttr1);
    let newObject = {
      from: 'human',
      suggestionCategory: [],
      category: [],
      suggestions: [],
      aiResponse: dataAttr2,
      time: moment().format('D MMM YYYY, h:mm A')
    }
    let updatedData = [ ...messages, newObject ];

    let apiEndpoint = APIBASEURL+'/suggestionCategory?parent_category_id='+dataAttr1;
    let config = {
      method: 'GET',
      maxBodyLength: Infinity,
      url: apiEndpoint,
      headers: { 
        'accept': '*/*', 
        'Authorization': `${localStorage.getItem('accessToken')}`
      }
    };
    axios.request(config)
    .then((response) => {
      
      let newObj = {
        from: 'suggestion',
        suggestionCategory: response.data.data ?? [],
        category: response.data.category ?? {},
        suggestions: response.data.suggestions ?? [],
        aiResponse: '',
        time: moment().format('D MMM YYYY, h:mm A')
      }
      if(response.data.suggestions.length > 0){
        setLastSelectedSuggestion(response.data.suggestions[0].id ?? 0);
      }
      updatedData = [ ...updatedData, newObj ];
      setMessage(updatedData);
  
    })
    .catch((error) => {
      if (error.response && error.response.status === 401) {
      // Unauthorized, handle the 401 error here
      console.log('Unauthorized access! Redirect to login or take other action.');
      localStorage.removeItem('accessToken');
      dispatch(logout());
      navigate('/');
    } else {
      // Handle other errors
      console.error('Error:', error);
    }
    });
    
  }

  let HandleSendMessage = () => {
    if(!transcript){
      toastId.current = toast.loading("Please enter something...", {
        position: "top-right",
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        autoClose: 2000,
        theme: "colored",
        type: "error"
      });
      setTimeout(() => {
        toast.dismiss( toastId.current);
      }, 1000);

      return false;
    }
    let currentMessage = transcript;
    setRegenerateTranscript(currentMessage);
    let apiEndpoint = APIBASEURL+'/suggestion/StreamChatGpt?user_id='+loggedInUser.id+'&question='+transcript;
    let question = transcript;
    let newObj = {
      from: 'human',
      suggestionCategory: [],
      suggestions: [],
      aiResponse: transcript,
      time: moment().format('D MMM YYYY, h:mm A')
    }
    let updatedData = [ ...messages, newObj ];
    const newObject = {
      from: 'assistant',
      suggestionCategory: [],
      category: [],
      suggestions: [],
      aiResponse: '',
      time: moment().format('D MMM YYYY, h:mm A')
    };
    updatedData = [ ...updatedData, newObject ];
    setMessage(updatedData);
    setTranscript('');
    const eventSource = new EventSource(apiEndpoint);
    let chatContent = ``;
    eventSource.onmessage = (event) => {
      const jsonString = event.data;
      const start = jsonString.indexOf('{');
      const end = jsonString.lastIndexOf('}');
  
      if (start !== -1 && end !== -1) {
        const jsonObject = jsonString.substring(start, end + 1);
        try {
          const parsedData = JSON.parse(jsonObject);
          const contentValue = parsedData.choices[0].delta.content;
          if(contentValue != undefined){
            const updatedItems = [ ...updatedData ]; 
            const lastItem = updatedItems[updatedItems.length - 1]; 
            lastItem.aiResponse = lastItem.aiResponse + contentValue;
            chatContent = chatContent + contentValue;
            setMessage(updatedItems);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('JSON object not found in the provided string.');
      }
    };

    eventSource.onerror = (error) => {
      /** Setup New suggestion */
      let saveChatHistoryApiEndpoint = APIBASEURL+'/chatHistory/web';
      const requestBody = {
        question: question,
        userId: loggedInUser.id,
        response: chatContent
      };
      const accessToken = localStorage.getItem('accessToken');
      axios.post(saveChatHistoryApiEndpoint, requestBody, {
        headers: {
          'Authorization': 'Bearer ' + accessToken
        }
      })
      .then(() => {
        checkNewHistories(!newHistories);
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          // Unauthorized, handle the 401 error here
          console.log('Unauthorized access! Redirect to login or take other action.');
          localStorage.removeItem('accessToken');
          dispatch(logout());
          navigate('/');
        } else {
          // Handle other errors
          console.error('Error:', error);
        }
      });
      setTimeout(() => {
        let nextSuggestionApiEndpoint = APIBASEURL+'/suggestion/getNextSuggestion?parent_category_id='+lastSelectedCategory+'&suggestion_id='+lastSelectedSuggestion+'&question='+transcript;
        let config = {
          method: 'GET',
          maxBodyLength: Infinity,
          url: nextSuggestionApiEndpoint,
          headers: { 
            'accept': '*/*', 
            'Authorization': `${localStorage.getItem('accessToken')}`
          }
        };
        axios.request(config)
        .then((response) => {
          if(response.data.suggestions.rows){
            if(response.data.suggestions.rows && response.data.suggestions.rows.length > 0){
              const newSuggestionObject = {
                from: 'suggestion',
                suggestionCategory: [],
                category: response.data.category ?? {},
                suggestions: response.data.suggestions ?? [],
                aiResponse: '',
                time: moment().format('D MMM YYYY, h:mm A')
              }
              if(response.data.suggestions.length > 0){
                setLastSelectedSuggestion(response.data.suggestions[0].id ?? 0);
              }
              updatedData = [ ...updatedData, newSuggestionObject ];
              setMessage(updatedData);
            }
          }
        });
      }, 100);
      console.error('EventSource failed:', error);
      eventSource.close();
      setMyEventSource(null);
    };

    eventSource.onclose = function() {
      let saveChatHistoryApiEndpoint = APIBASEURL+'/chatHistory/web';
      const requestBody = {
        question: question,
        userId: loggedInUser.id,
        response: chatContent
      };
      const accessToken = localStorage.getItem('accessToken');
      axios.post(saveChatHistoryApiEndpoint, requestBody, {
        headers: {
          'Authorization': 'Bearer ' + accessToken
        }
      })
      .then(() => {
        checkNewHistories(!newHistories);
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          // Unauthorized, handle the 401 error here
          console.log('Unauthorized access! Redirect to login or take other action.');
          localStorage.removeItem('accessToken');
          dispatch(logout());
          navigate('/');
        } else {
          // Handle other errors
          console.error('Error:', error);
        }
      });
      setTimeout(() => {
        let nextSuggestionApiEndpoint = APIBASEURL+'/suggestion/getNextSuggestion?parent_category_id='+lastSelectedCategory+'&suggestion_id='+lastSelectedSuggestion+'&question='+transcript;
        let config = {
          method: 'GET',
          maxBodyLength: Infinity,
          url: nextSuggestionApiEndpoint,
          headers: { 
            'accept': '*/*', 
            'Authorization': `${localStorage.getItem('accessToken')}`
          }
        };
        axios.request(config)
        .then((response) => {
          if(response.data.suggestions.rows){
            if(response.data.suggestions.rows && response.data.suggestions.rows.length > 0){
              const newSuggestionObject = {
                from: 'suggestion',
                suggestionCategory: [],
                category: response.data.category ?? {},
                suggestions: response.data.suggestions ?? [],
                aiResponse: '',
                time: moment().format('D MMM YYYY, h:mm A')
              }
              if(response.data.suggestions.length > 0){
                setLastSelectedSuggestion(response.data.suggestions[0].id ?? 0);
              }
              updatedData = [ ...updatedData, newSuggestionObject ];
              setMessage(updatedData);
            }
          }
        });
      }, 100);
      setMyEventSource(null);
    };
    setMyEventSource(eventSource);
    checkNewHistories(!newHistories);
    scrollToBottom();
  };

  const handleToggle = () => {
    setToggle(!isToggled);
    if(isToggled === true){
      $('#SidebarContainer').css('display', 'block');
    }else{
      $('#SidebarContainer').css('display', 'none');
    }
  };

  let HandleTextAreaChange = (e) => {
    setTranscript(e.target.value)
  }

  const recognition = new (window.SpeechRecognition || window.webkitSpeechRecognition)();
  // Configure the SpeechRecognition object
  recognition.continuous = true; // Continuous listening
  recognition.interimResults = true; // Get intermediate results
  recognition.lang = 'en-US'; // Language

  recognition.onresult = (event) => {
    let finalTranscript = '';
    for (let i = event.resultIndex; i < event.results.length; i++) {
      const transcript = event.results[i][0].transcript;
      if (event.results[i].isFinal) {
        finalTranscript += transcript + ' ';
      } else {
        finalTranscript += transcript;
      }
    }

    setTranscript(finalTranscript);
    setIsListening(false);
  };

  const startListening = () => {
    recognition.start();
    setIsListening(true);
  };

  const stopListening = () => {
    recognition.stop();
    setIsListening(false);
  };

  const HandleNewChat = () => {
    let apiEndpoint = APIBASEURL+'/suggestion/StreamChatGpt?is_new_chat=true&user_id='+loggedInUser.id+'&question=';
    
    let config = {
      method: 'GET',
      maxBodyLength: Infinity,
      url: apiEndpoint,
      headers: { 
        'accept': '*/*', 
        'Authorization': `${localStorage.getItem('accessToken')}`
      }
    };
    axios.request(config)
    .then((response) => {
      console.log(response);
    })
    .catch((error) => {
      if (error.response && error.response.status === 401) {
      // Unauthorized, handle the 401 error here
      console.log('Unauthorized access! Redirect to login or take other action.');
      localStorage.removeItem('accessToken');
      dispatch(logout());
      navigate('/');
    } else {
      // Handle other errors
      console.error('Error:', error);
    }
    });
    setMessage([]);
    setNewChatMessage(!newChatMessage);
  }

  const HandleSuggestionChoose = (e) => {
    const dataAttr1 = e.target.getAttribute('data-suggestion-id');
    const dataAttr2 = e.target.getAttribute('data-suggestion-title');
    setLastSelectedSuggestion(dataAttr1);
    setTranscript(dataAttr2);
    setTimeout(() => {
      $('#send-button').click();
    }, 250);
  }

  const handleChatDelete = (e) => {
    const chatId = e.target.getAttribute('data-chat-id');
    let apiEndpoint = APIBASEURL+'/chatHistory/'+chatId;
    let config = {
      method: 'DELETE',
      maxBodyLength: Infinity,
      url: apiEndpoint,
      headers: { 
        'accept': '*/*', 
        'Authorization': `${localStorage.getItem('accessToken')}`
      }
    };
    axios.request(config)
    .then(() => {
      toastId.current = toast.loading("Chat deleted successfully.", {
        position: "top-right",
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        autoClose: 2500,
        theme: "colored",
        type: "success"
      });
      setIsDeletingChat(!isDeletingChat);
      setTimeout(() => {
        toast.dismiss( toastId.current);
      }, 1500);
    })
    .catch((error) => {
      if (error.response && error.response.status === 401) {
      // Unauthorized, handle the 401 error here
      console.log('Unauthorized access! Redirect to login or take other action.');
      localStorage.removeItem('accessToken');
      dispatch(logout());
      navigate('/');
    } else {
      // Handle other errors
      console.error('Error:', error);
    }
    });

  }

  const handleEnterPress = (event) => {
    if (event.key === 'Enter' && !event.shiftKey) {
      HandleSendMessage();
      event.preventDefault(); // This prevents adding a newline character to the textarea.
    }
  };

  const scrollToTop = () => {
    divRef.current.scrollTop = 0;
  };

  const handleRegenerateResponse = () => {
      if(!regenerateTranscript){
        toastId.current = toast.loading("Please enter something...", {
          position: "top-right",
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          autoClose: 2000,
          theme: "colored",
          type: "error"
        });
        setTimeout(() => {
          toast.dismiss( toastId.current);
        }, 1000);
  
        return false;
      }
      let currentMessage = regenerateTranscript;
      setRegenerateTranscript(currentMessage);
      let apiEndpoint = APIBASEURL+'/suggestion/StreamChatGpt?user_id='+loggedInUser.id+'&question='+regenerateTranscript;
      let question = regenerateTranscript;
      let newObj = {
        from: 'human',
        suggestionCategory: [],
        suggestions: [],
        aiResponse: regenerateTranscript,
        time: moment().format('D MMM YYYY, h:mm A')
      }
      let updatedData = [ ...messages, newObj ];
      const newObject = {
        from: 'assistant',
        suggestionCategory: [],
        category: [],
        suggestions: [],
        aiResponse: '',
        time: moment().format('D MMM YYYY, h:mm A')
      };
      updatedData = [ ...updatedData, newObject ];
      setMessage(updatedData);
      setTranscript('');
      const eventSource = new EventSource(apiEndpoint);
      let chatContent = ``;
      eventSource.onmessage = (event) => {
        const jsonString = event.data;
        const start = jsonString.indexOf('{');
        const end = jsonString.lastIndexOf('}');
    
        if (start !== -1 && end !== -1) {
          const jsonObject = jsonString.substring(start, end + 1);
          try {
            const parsedData = JSON.parse(jsonObject);
            const contentValue = parsedData.choices[0].delta.content;
            if(contentValue != undefined){
              const updatedItems = [ ...updatedData ]; 
              const lastItem = updatedItems[updatedItems.length - 1]; 
              lastItem.aiResponse = lastItem.aiResponse + contentValue;
              chatContent = chatContent + contentValue;
              setMessage(updatedItems);
            }
          } catch (error) {
            console.error('Error parsing JSON:', error);
          }
        } else {
          console.error('JSON object not found in the provided string.');
        }
      };
  
      eventSource.onerror = (error) => {
        /** Setup New suggestion */
        let saveChatHistoryApiEndpoint = APIBASEURL+'/chatHistory/web';
        const requestBody = {
          question: question,
          userId: loggedInUser.id,
          response: chatContent
        };
        const accessToken = localStorage.getItem('accessToken');
        axios.post(saveChatHistoryApiEndpoint, requestBody, {
          headers: {
            'Authorization': 'Bearer ' + accessToken
          }
        })
        .then(() => {
          checkNewHistories(!newHistories);
        })
        .catch((error) => {
          if (error.response && error.response.status === 401) {
            // Unauthorized, handle the 401 error here
            console.log('Unauthorized access! Redirect to login or take other action.');
            localStorage.removeItem('accessToken');
            dispatch(logout());
            navigate('/');
          } else {
            // Handle other errors
            console.error('Error:', error);
          }
        });
        setTimeout(() => {
          let nextSuggestionApiEndpoint = APIBASEURL+'/suggestion/getNextSuggestion?parent_category_id='+lastSelectedCategory+'&suggestion_id='+lastSelectedSuggestion+'&question='+regenerateTranscript;
          let config = {
            method: 'GET',
            maxBodyLength: Infinity,
            url: nextSuggestionApiEndpoint,
            headers: { 
              'accept': '*/*', 
              'Authorization': `${localStorage.getItem('accessToken')}`
            }
          };
          axios.request(config)
          .then((response) => {
            if(response.data.suggestions.rows){
              if(response.data.suggestions.rows && response.data.suggestions.rows.length > 0){
                const newSuggestionObject = {
                  from: 'suggestion',
                  suggestionCategory: [],
                  category: response.data.category ?? {},
                  suggestions: response.data.suggestions ?? [],
                  aiResponse: '',
                  time: moment().format('D MMM YYYY, h:mm A')
                }
                if(response.data.suggestions.length > 0){
                  setLastSelectedSuggestion(response.data.suggestions[0].id ?? 0);
                }
                updatedData = [ ...updatedData, newSuggestionObject ];
                setMessage(updatedData);
              }
            }
          });
        }, 100);
        console.error('EventSource failed:', error);
        eventSource.close();
        setMyEventSource(null);
      };
  
      eventSource.onclose = function() {
        let saveChatHistoryApiEndpoint = APIBASEURL+'/chatHistory/web';
        const requestBody = {
          question: question,
          userId: loggedInUser.id,
          response: chatContent
        };
        const accessToken = localStorage.getItem('accessToken');
        axios.post(saveChatHistoryApiEndpoint, requestBody, {
          headers: {
            'Authorization': 'Bearer ' + accessToken
          }
        })
        .then(() => {
          checkNewHistories(!newHistories);
        })
        .catch((error) => {
          if (error.response && error.response.status === 401) {
            // Unauthorized, handle the 401 error here
            console.log('Unauthorized access! Redirect to login or take other action.');
            localStorage.removeItem('accessToken');
            dispatch(logout());
            navigate('/');
          } else {
            // Handle other errors
            console.error('Error:', error);
          }
        });
        setTimeout(() => {
          let nextSuggestionApiEndpoint = APIBASEURL+'/suggestion/getNextSuggestion?parent_category_id='+lastSelectedCategory+'&suggestion_id='+lastSelectedSuggestion+'&question='+regenerateTranscript;
          let config = {
            method: 'GET',
            maxBodyLength: Infinity,
            url: nextSuggestionApiEndpoint,
            headers: { 
              'accept': '*/*', 
              'Authorization': `${localStorage.getItem('accessToken')}`
            }
          };
          axios.request(config)
          .then((response) => {
            if(response.data.suggestions.rows){
              if(response.data.suggestions.rows && response.data.suggestions.rows.length > 0){
                const newSuggestionObject = {
                  from: 'suggestion',
                  suggestionCategory: [],
                  category: response.data.category ?? {},
                  suggestions: response.data.suggestions ?? [],
                  aiResponse: '',
                  time: moment().format('D MMM YYYY, h:mm A')
                }
                if(response.data.suggestions.length > 0){
                  setLastSelectedSuggestion(response.data.suggestions[0].id ?? 0);
                }
                updatedData = [ ...updatedData, newSuggestionObject ];
                setMessage(updatedData);
              }
            }
          });
        }, 100);
        setMyEventSource(null);
      };
      setMyEventSource(eventSource);
      checkNewHistories(!newHistories);
      scrollToBottom();
  };

  const handleStopResponse = () => {
    console.log('stopping...');
    if (myEventSource) {
      myEventSource.close();
    }
  };

  const handleOpenHistory = (e) => {
    const chatQuestion = e.target.getAttribute('data-chat-question');
    setRegenerateTranscript(chatQuestion);
    setTimeout(() => {
      if(!chatQuestion){
        toastId.current = toast.loading("Please enter something...", {
          position: "top-right",
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          autoClose: 2000,
          theme: "colored",
          type: "error"
        });
        setTimeout(() => {
          toast.dismiss( toastId.current);
        }, 1000);
  
        return false;
      }
      let currentMessage = chatQuestion;
      setRegenerateTranscript(currentMessage);
      let apiEndpoint = APIBASEURL+'/suggestion/StreamChatGpt?user_id='+loggedInUser.id+'&question='+chatQuestion;
      let question = chatQuestion;
      let newObj = {
        from: 'human',
        suggestionCategory: [],
        suggestions: [],
        aiResponse: chatQuestion,
        time: moment().format('D MMM YYYY, h:mm A')
      }
      let updatedData = [ ...messages, newObj ];
      const newObject = {
        from: 'assistant',
        suggestionCategory: [],
        category: [],
        suggestions: [],
        aiResponse: '',
        time: moment().format('D MMM YYYY, h:mm A')
      };
      updatedData = [ ...updatedData, newObject ];
      setMessage(updatedData);
      setTranscript('');
      const eventSource = new EventSource(apiEndpoint);
      let chatContent = ``;
      eventSource.onmessage = (event) => {
        const jsonString = event.data;
        const start = jsonString.indexOf('{');
        const end = jsonString.lastIndexOf('}');
    
        if (start !== -1 && end !== -1) {
          const jsonObject = jsonString.substring(start, end + 1);
          try {
            const parsedData = JSON.parse(jsonObject);
            const contentValue = parsedData.choices[0].delta.content;
            if(contentValue != undefined){
              const updatedItems = [ ...updatedData ]; 
              const lastItem = updatedItems[updatedItems.length - 1]; 
              lastItem.aiResponse = lastItem.aiResponse + contentValue;
              chatContent = chatContent + contentValue;
              setMessage(updatedItems);
            }
          } catch (error) {
            console.error('Error parsing JSON:', error);
          }
        } else {
          console.error('JSON object not found in the provided string.');
        }
      };
  
      eventSource.onerror = (error) => {
        /** Setup New suggestion */
        let saveChatHistoryApiEndpoint = APIBASEURL+'/chatHistory/web';
        const requestBody = {
          question: question,
          userId: loggedInUser.id,
          response: chatContent
        };
        const accessToken = localStorage.getItem('accessToken');
        axios.post(saveChatHistoryApiEndpoint, requestBody, {
          headers: {
            'Authorization': 'Bearer ' + accessToken
          }
        })
        .then(() => {
          checkNewHistories(!newHistories);
        })
        .catch((error) => {
          if (error.response && error.response.status === 401) {
            // Unauthorized, handle the 401 error here
            console.log('Unauthorized access! Redirect to login or take other action.');
            localStorage.removeItem('accessToken');
            dispatch(logout());
            navigate('/');
          } else {
            // Handle other errors
            console.error('Error:', error);
          }
        });
        setTimeout(() => {
          let nextSuggestionApiEndpoint = APIBASEURL+'/suggestion/getNextSuggestion?parent_category_id='+lastSelectedCategory+'&suggestion_id='+lastSelectedSuggestion+'&question='+chatQuestion;
          let config = {
            method: 'GET',
            maxBodyLength: Infinity,
            url: nextSuggestionApiEndpoint,
            headers: { 
              'accept': '*/*', 
              'Authorization': `${localStorage.getItem('accessToken')}`
            }
          };
          axios.request(config)
          .then((response) => {
            if(response.data.suggestions.rows){
              if(response.data.suggestions.rows && response.data.suggestions.rows.length > 0){
                const newSuggestionObject = {
                  from: 'suggestion',
                  suggestionCategory: [],
                  category: response.data.category ?? {},
                  suggestions: response.data.suggestions ?? [],
                  aiResponse: '',
                  time: moment().format('D MMM YYYY, h:mm A')
                }
                if(response.data.suggestions.length > 0){
                  setLastSelectedSuggestion(response.data.suggestions[0].id ?? 0);
                }
                updatedData = [ ...updatedData, newSuggestionObject ];
                setMessage(updatedData);
              }
            }
          });
        }, 100);
        console.error('EventSource failed:', error);
        eventSource.close();
        setMyEventSource(null);
      };
  
      eventSource.onclose = function() {
        let saveChatHistoryApiEndpoint = APIBASEURL+'/chatHistory/web';
        const requestBody = {
          question: question,
          userId: loggedInUser.id,
          response: chatContent
        };
        const accessToken = localStorage.getItem('accessToken');
        axios.post(saveChatHistoryApiEndpoint, requestBody, {
          headers: {
            'Authorization': 'Bearer ' + accessToken
          }
        })
        .then(() => {
          checkNewHistories(!newHistories);
        })
        .catch((error) => {
          if (error.response && error.response.status === 401) {
            // Unauthorized, handle the 401 error here
            console.log('Unauthorized access! Redirect to login or take other action.');
            localStorage.removeItem('accessToken');
            dispatch(logout());
            navigate('/');
          } else {
            // Handle other errors
            console.error('Error:', error);
          }
        });
        setTimeout(() => {
          let nextSuggestionApiEndpoint = APIBASEURL+'/suggestion/getNextSuggestion?parent_category_id='+lastSelectedCategory+'&suggestion_id='+lastSelectedSuggestion+'&question='+chatQuestion;
          let config = {
            method: 'GET',
            maxBodyLength: Infinity,
            url: nextSuggestionApiEndpoint,
            headers: { 
              'accept': '*/*', 
              'Authorization': `${localStorage.getItem('accessToken')}`
            }
          };
          axios.request(config)
          .then((response) => {
            if(response.data.suggestions.rows){
              if(response.data.suggestions.rows && response.data.suggestions.rows.length > 0){
                const newSuggestionObject = {
                  from: 'suggestion',
                  suggestionCategory: [],
                  category: response.data.category ?? {},
                  suggestions: response.data.suggestions ?? [],
                  aiResponse: '',
                  time: moment().format('D MMM YYYY, h:mm A')
                }
                if(response.data.suggestions.length > 0){
                  setLastSelectedSuggestion(response.data.suggestions[0].id ?? 0);
                }
                updatedData = [ ...updatedData, newSuggestionObject ];
                setMessage(updatedData);
              }
            }
          });
        }, 100);
        setMyEventSource(null);
      };
      setMyEventSource(eventSource);
      checkNewHistories(!newHistories);
      scrollToBottom();
    }, 500);
  };

  const getUserAvtar = () => {
    let FirstLetter = '';
    let LastLetter = '';
    let fullName = (loggedInUser) ? loggedInUser.first_name+' '+loggedInUser.last_name : '';
    if(fullName){
      const items = fullName.split(' ');
      if(items[0]){
        FirstLetter = items[0][0] ?? '';
      }
      if(items[1]){
        LastLetter = items[1][0] ?? '';
      }
      return FirstLetter+LastLetter;
    }
    return '';
  }

  return (
    <div >
      {
        (loading)
        ?
        <div className="loading-container">
          <div className="loading-spinner"/>
        </div>
        :
        ''
      }
      
      <HelmetProvider>
        <Helmet>
          <title>Simplyenglish AI: Conversation</title>
        </Helmet>
      </HelmetProvider>
      <section id="chat-background">
        <div className="container-fluid">
          <div className="row chat-background">
            <div className="col-lg-3 col-md-3 col-sm12 p-0 col-contacts-border" id="SidebarContainer">
              <div className="ai-contacts-top">
                <div className="mb-1 flex flex-row gap-2 mt-1 w-100" >
                  <a className="flex mt-2 p-3 items-center gap-3 h-11 w-75 cursor-pointer text-sm rounded-sm border flex-shrink-0 flex-grow text-decoration-none" onClick={HandleNewChat}><i className="fa fa-plus mr-2" /> New chat</a>
                  <span  data-state="closed"  onClick={handleToggle}>
                    <a className="flex p-2 mt-2 items-center gap-3 cursor-pointer text-sm rounded-sm border flex-shrink-0 flex-grow h-11 w-11 items-center justify-content-center text-decoration-none" title='Close Sidebar'>
                      {/* <i className="fa fa-bars"/> */}
                      <img src="../images/sidebar.png" alt="Simplyenglish AI" title='Close Sidebar'/>
                    </a>
                  </span>
                </div>
              </div>

              <div className="ai-contacts-scroll mb-5">

                <h3 className="history-badge">Today</h3>

                {
                  (chatHistories.today_history && chatHistories.today_history.length > 0)
                  ?
                  chatHistories.today_history.map((chatHistory, indx) => {
                    return <div className="ai-contacts-item ai_contacts_active_1 ai-contacts-item-active" data-index="1" key={indx}>
                      <div className="ai-contacts-info">
                        <div className="ai-contacts-job" alt="">
                          <div className="HistoryTextContainer" data-chat-question={chatHistory.question} onClick={handleOpenHistory}>
                            <i className="fa fa-comment" /> {chatHistory.question}
                          </div>
    
                          <button className="btn-chat-history">
                            <i className="fa fa-trash" data-chat-id={chatHistory.id} onClick={handleChatDelete}/>
                          </button>
    
                        </div>
                      </div>
                    </div>
                  })
                  :
                  ''
                }

                <h3 className="history-badge">Previous 7 days</h3>

                {
                  (chatHistories.seven_days_history && chatHistories.seven_days_history.length > 0)
                  ?
                  chatHistories.seven_days_history.map((chatHistory, indx) => {
                    return <div className="ai-contacts-item ai_contacts_active_1 ai-contacts-item-active" data-index="1" key={indx}>
                      <div className="ai-contacts-info">
                        <div className="ai-contacts-job" alt="">
                          <div className="HistoryTextContainer" data-chat-question={chatHistory.question} onClick={handleOpenHistory}>
                            <i className="fa fa-comment" /> {chatHistory.question}
                          </div>
    
                          <button className="btn-chat-history">
                            <i className="fa fa-trash" data-chat-id={chatHistory.id} onClick={handleChatDelete}/>
                          </button>
    
                        </div>
                      </div>
                    </div>
                  })
                  :
                  ''
                }
                
              </div>
            </div>
            <div className="col p-0 col-main-chat">
              <header className="header-min">
                <div className="container-fluid">
                  <div className="row align-items-center">
                    <div className="col-lg-6 col-md-6 col-sm-12 d-flex justify-content-md-start justify-content-sm-center">
                      {
                        (isToggled === true)
                        ?
                        <img src="../images/sidebar.png" className='OpenSidebarBtn' alt="Simplyenglish AI" onClick={handleToggle} title="Open Sidebar"/>
                        // <i className="fa fa-bars OpenSidebarBtn" onClick={handleToggle} title='Open Sidebar'/>
                        :
                        ''
                      }
                      
                        
                      <span className="header-slogan"><span className="translate-slogan">Welcome {(loggedInUser) ? loggedInUser.first_name : ''} <Link
                          onClick = {(e) => handlerLogout(e)}
                        >
                          <i className="fa fa-sign-out mr-2 primary-text" title='Logout' />
                        </Link></span></span>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 d-flex justify-content-md-end justify-content-sm-center">
                      <a href="/"><img src="../images/logo.png" alt="Simplyenglish AI" title="Simplyenglish AI" id="logo" /></a>
                    </div>

                  </div>
                </div>
              </header>

              <div className="ai-chat-top">
                <div className="row align-items-left">
                  <div className="col-md-7 col-lg-8 col-7">
                    <div className="col-lg-6 col-md-6 col-sm-12 d-flex justify-content-md-start justify-content-sm-center">
                                                 
                        <span className="header-slogan mt-4"><span className="translate-slogan">Welcome {(loggedInUser) ? loggedInUser.first_name : ''} <Link
                            onClick = {(e) => handlerLogout(e)}
                          >
                            <i className="fa fa-sign-out mr-2 primary-text" />
                          </Link></span>
                        </span>
                      </div>
                  </div>
                  <div className="col-md-5 col-lg-4 col-5">
                    <div className="icons-options">
                    <a href="/"><img src="../images/logo.png" alt="Simplyenglish AI" title="Simplyenglish AI"/></a>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="ia-chat-content">
                <div className="row">
                  <div className="cell">
                    <div className="chat-frame">
                      <div id="overflow-chat" ref={divRef}>
                      
                        {
                          (messages.length > 0)
                            ?
                            messages.map((message, index) => {
                              return<>
                                {
                                (message.from === 'suggestion')
                                ?
                                <>
                                <div className="conversation-thread thread-ai">
                                  <div className="user-image"><img src="../images/user-icon.png" alt="Simplyenglish AI"
                                    title="Simplyenglish AI" /></div>
                                  <div className="message-container">
                                      <TextToSpeech content={(message.category)
                                        ?
                                        message.category.description ?? 'What would you like to learn today?'
                                        :
                                        ''
                                      } />
                                    <div className="message-info">
                                      <CopyButton content={(message.category)
                                        ?
                                        message.category.description ?? 'What would you like to learn today?'
                                        :
                                        ''
                                      } />
                                      <div className="message-text">
                                        <div className="chat-response">
                                          {
                                            (message.category)
                                            ?
                                            message.category.description ?? 'What would you like to learn today?'
                                            :
                                            ''
                                          }
                                        </div>
                                        <div className="date-chat"><img src="../images/icon-clock.svg" />{message.time}</div>
                                      </div>
  
                                    </div>
                                  </div>
                                </div>
                                {
                                  (message.suggestions.rows && message.suggestions.rows.length > 0)
                                  ?

                                  <div className={expandedItem === index ? 'message-container-suggestion suggestions-container expanded' : 'message-container-suggestion suggestions-container'}>
                                    <div className="message-info">
                                      <button className="copy-text">

                                        <span className="label-copy-code"><i className="fa-solid fa-copy" /></span></button>
                                      <div className="message-text">
                                        {
                                          message.suggestions.rows.map((item, index2) => {
                                            return <span className="label label-success" key={index2} data-suggestion-id={item.id}      data-suggestion-title={item.title} onClick={HandleSuggestionChoose}>{item.title}</span>
                                        
                                          })
                                        }
                                        
                                      </div>

                                    </div>
                                  </div>
                                  :
                                  ''
                                }
                                <div className="conversation-thread thread-ai">
                                  <div className="user-image">
                                    <img style={{'display': 'none'}} src="../images/logo.png" alt="Simplyenglish AI"
                                    title="Simplyenglish AI" />
                                    </div>
                                  <div className={expandedItem === index ? 'message-container-suggestion expanded' : 'message-container-suggestion'}>
                                    <div className="message-info">
                                      <div className="message-text">
                                        {
                                          message.suggestionCategory.map((item, index) => {
                                            return <span className="label label-success" key={index} onClick={HandleChooseCategory} data-category-id={item.id} data-category-title={item.title}>{item.title}</span>
                                        
                                          })
                                        }
                                        
                                      </div>
  
                                    </div>
                                  </div>
                                </div>
                                {
                                (message.suggestionCategory.length > 10)
                                ?
                                <button className='collapse-toggle-btn' onClick={() => toggleExpand(index)}>
                                  {expandedItem === index ? 'Show more...' : 'Show less...'}
                                </button>
                                :
                                ''
                                }
                                </>
                                :
                                ''
                                }

                                {
                                  (message.from === 'assistant')
                                  ?
                                  <>
                                  <div className={'conversation-thread thread-ai'}>
                                    <div className="user-image"><img src="../images/user-icon.png" alt="Simplyenglish AI"
                                      title="Simplyenglish AI" /></div>
                                    <div className="message-container">
                                      <div className="message-info">
                                        <TextToSpeech content={message.aiResponse} />
                                        <CopyButton content={message.aiResponse}/>
                                        <div className="message-text">
                                          <div className={expandedItem === index ? 'chat-response expanded' : 'chat-response'}>{message.aiResponse}
                                          </div>
                                          <div className="date-chat"><img src="../images/icon-clock.svg" /> {message.time}</div>
                                        </div>
                                        {/* suggestion show more button */}
                                        {
                                          (message.aiResponse.trim().split(/\s+/).length > 100)
                                          ?
                                          <button className='collapse-toggle-btn-ai' onClick={() => toggleExpand(index)}>
                                            {expandedItem === index ? 'Show more...' : 'Show less...'}
                                          </button>
                                          :
                                          ''
                                        }
                                        
                                      </div>
                                    </div>
                                  </div>
                                  
                                  </>
                                  :
                                  ''
                                }

                                {
                                  (message.from === 'human')
                                  ?
                                  <div className="conversation-thread thread-user">
                                    {
                                      (getUserAvtar())
                                      ?
                                      <div className="user-avtar">
                                        {getUserAvtar().toUpperCase()}
                                      </div>
                                      :
                                      ''
                                    }
                                    <div className="message-container">
                                      <TextToSpeech content={message.aiResponse} />
                                      <div className="message-info">
                                        <CopyButton content={message.aiResponse}/>
                                        <div className="message-text">
                                          <div className="chat-response">{message.aiResponse}</div>
                                        </div>
                                        <div className="date-chat"><img src="../images/icon-clock.svg" />{message.time}</div>
                                      </div>
                                    </div>
                                  </div>
                                  :
                                  ''
                                }
                              </>
                            })
                            :
                            ''
                        }

                      </div>
                        {/* <span className="scroll-to-bottom">
                          <i className="fa fa-arrow-circle-down" onClick={scrollToBottom} aria-hidden="true"/>
                        </span> */}
                        <span className="scroll-to-top">
                          <i className="fa fa-arrow-circle-up" onClick={scrollToTop} aria-hidden="true" title='Scroll To Top'/>
                        </span>
                        {
                          (regenerateTranscript)
                          ?
                          <span className="regenrate-container">
                            <i className="fa fa-refresh regenrate-btn" onClick={handleRegenerateResponse} aria-hidden="true" title='Regenerate'/>
                          </span>
                          :
                          ''
                        }
                        
                        {
                          (myEventSource)
                          ?
                          <span className="stop-container">
                            <i className="fa fa-stop stop-btn" onClick={handleStopResponse}  aria-hidden="true" title='Stop'/>
                          </span>
                          :
                          ''
                        }
                        
                    </div>
                    
                    <div className="message-area-bottom">
                      <div className="chat-input">
                                                
                        <textarea value={transcript} name="chat" id="chat" placeholder="Type your message here" onChange={HandleTextAreaChange} onKeyPress={handleEnterPress}/>

                        <img src="../images/send-button.png" id="send-button" onClick={HandleSendMessage} title='Send Message'/>
                        {
                          (isListening)
                          ?
                          <img className="microphone-buttons2" src="../images/microphone.gif" id="microphone-button" onClick={stopListening} title='Mic Stop'/>
                          :
                          <img className="microphone-buttons" src="../images/microphone.png" id="microphone-button" onClick={startListening} title='Mic Start'/>

                        }
                        
                        
                      </div>
                    </div>
                    
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Dashboard;
